export default __webpack_public_path__ + "static/media/litho-demo-design-agency.eff48550.jpg";